export default __webpack_public_path__ + "static/media/fashion_model_1.a6a21fd6.png";